
import { ITableAction } from "../../../../interfaces";
import {
  StyledHeaderCell,
  StyledTableHeader,
} from "../../../../styles/components/tables";


interface ITableHeadProps {
  rowActions?: Array<ITableAction>;
  headers: Array<{ key: string; label: string; keyTranslate?: string }>;
}

export const TableHead = ({ headers, rowActions }: ITableHeadProps) => {
  return (
    <thead>
      <StyledTableHeader className="text-[#5E5E5E]">
        {headers.map(
          (
            headerItem: { key: string; label: string; keyTranslate?: string },
            key: number
          ) => (
            <StyledHeaderCell key={key}>
              <div className="flex gap-5 justify-center">
                <span className="font-bold text-[#1AA5C0] w-max">
           
                    {headerItem.label}
                
                </span>
              </div>
            </StyledHeaderCell>
          )
        )}
        {rowActions?.length ? (
          <StyledHeaderCell key={"actions"}>
            <div className="flex gap-5 justify-center">
              <span className="font-bold text-[#1AA5C0]">Actions</span>
            </div>
          </StyledHeaderCell>
        ) : (
          ""
        )}
      </StyledTableHeader>
    </thead>
  );
};
